import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockArticles, categories } from '@/mocks/articles';

export default function ArticleList() {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const articles = mockArticles.filter((a) => !a.featured);

  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新资讯
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            日韩娱乐每日新鲜内容
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap mb-8">
        <button
          onClick={() => setActiveCategory('all')}
          className={`px-4 py-2 rounded-full text-xs font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
            activeCategory === 'all'
              ? 'bg-foreground-950 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          全部
        </button>
        {categories.map((cat) => (
          <button
            key={cat.slug}
            onClick={() => setActiveCategory(cat.slug)}
            className={`px-4 py-2 rounded-full text-xs font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              activeCategory === cat.slug
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredArticles.map((article) => (
          <article key={article.id} className="group cursor-pointer">
            <Link to={`/article/${article.id}`} className="block">
              <div className="relative overflow-hidden rounded-lg aspect-[16/10] mb-4">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-primary-50 text-primary-700">
                  {getCategoryLabel(article.category)}
                </span>
                <span className="text-xs text-foreground-500">{article.publishedAt}</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{article.author}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line text-[11px]"></i>
                  {article.views.toLocaleString()}
                </span>
              </div>
            </Link>
          </article>
        ))}
      </div>

      {filteredArticles.length === 0 && (
        <div className="text-center py-16">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-inbox-line text-2xl text-foreground-400"></i>
          </div>
          <p className="text-sm text-foreground-500">暂无该分类的文章</p>
        </div>
      )}

      {filteredArticles.length > 6 && (
        <div className="mt-10 text-center">
          <button className="px-8 py-3 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            加载更多
            <i className="ri-arrow-down-line ml-1"></i>
          </button>
        </div>
      )}
    </section>
  );
}

function getCategoryLabel(slug: string): string {
  const map: Record<string, string> = {
    'japan-drama': '日剧',
    'korea-drama': '韩剧',
    'japan-movie': '日本电影',
    'korea-movie': '韩国电影',
    'kpop': 'K-POP',
    'jpop': 'J-POP',
    'variety': '综艺',
    'star': '明星',
  };
  return map[slug] || slug;
}